import { css } from 'linaria';

export const dropzoneCapInsideContent = css`
  width: 100%;
`;

export const dropzoneCapInsideLabel = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 0;
  flex-shrink: 0;

  box-sizing: border-box;
  width: 100%;
  padding-right: 16px;

  padding-left: 16px;

  height: var(--space-1000);
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);
  transition: background-color 0.3s;
  cursor: pointer;

  &:hover {
    background-color: var(--control-hover-secondary);
  }
`;

export const dropzoneCapInsideCaption = css`
  margin-top: 8px;
`;

export const inputContainer = css`
  display: none;
`;
